declare global {
  interface Window {
    /** 배포 컨테이너의 envsubst가 생성하는 런타임 환경 주입 (public/env.js) */
    __ENV?: Record<string, string | undefined>;
  }
}

export function getRuntimeEnvVar(
  key: string,
  buildTimeValue: string | undefined,
  defaultValue: string = ""
): string {
  // dev 서버에서는 빌드타임 env(.env/.env.local)가 우선한다.
  // public/env.js(window.__ENV)는 배포 컨테이너가 기동 시 envsubst로
  // 생성하는 런타임 주입 아티팩트인데, vite dev는 public/을 그대로
  // 서빙하므로 저장소의 기본값(스테이지 주소)이 로컬 설정을 가려
  // 모든 요청이 스테이지로 새어 나간다 (실측).
  if (import.meta.env.DEV && buildTimeValue) {
    return buildTimeValue;
  }
  if (typeof window !== "undefined" && window.__ENV?.[key] != null) {
    return window.__ENV[key];
  }
  return buildTimeValue || defaultValue;
}
